import { ViewChild, Component, OnInit, Output, EventEmitter, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { ToastService } from 'ng-uikit-pro-standard';
import { SharedService } from '../../../shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { AppConstants } from '../../../config.service';
import { UploadService } from '../../../header/header-component/upload/upload.service';
import { UtilitiesService } from '../../../shared/utilities.service';
import {GlobalConstants} from '../../../global-constants'
import {AuthService} from '../../../auth.service';

@Component({
    selector: 'add-document-modal',
    templateUrl: 'add-document-modal.component.html',
    styles: [`
    .modal-body .dropbox {
      font-size: 14px;
      border: 3px dashed #ededed;
      height: 90px;
      text-align: center;
      cursor: pointer;
      color: #999;
      padding-top: 20px;
      margin: 10px;
    }
    .modal-body .removeType {
      position: absolute;
      top: 15px;
      right: 18px;
      z-index: 10;
      color: silver;
    }
    .modal-body .drop-list {
      max-height: 150px;
      overflow: auto;
    }
    `]
})

export class AddDocumentModalComponent implements OnInit {

    @ViewChild('dropDocumentsModal', { static: true })
    dropDocumentsModal: any;
    @Output('confirmUpdate') confirmUpdate = new EventEmitter<boolean>();
    @ViewChildren('uploader') uploaderInput: QueryList<ElementRef>;
    selectedDevice: any = {};

    constructor(
        private KeycloakService: KeycloakService,
        private service: SharedService,
        private appConstants: AppConstants,
        public  toastr: ToastService,
        private UploadService: UploadService,
        private UtilitiesService: UtilitiesService,
        private translate : TranslateService,
        private authService : AuthService
    ) { }

    userInfo: any = {}
     ngOnInit() {
            const user = this.appConstants.userDetails
            this.userInfo = user
    }


    uploadFile(event, type, ev) {
        for (let index = 0; index < event.length; index++) {
            const element = event[index];
            element['id'] = Date.now() + Math.random()

            if (type && type.files == undefined)
                type['files'] = [];
            type.files.push(element)

        }
        if (ev && ev.target)
            ev.target.value = null
    }

    doc: any = [];
    async startUpload() {
        const getLocalSprig = localStorage.getItem('selectedDevice')
        const selectedDevice = getLocalSprig ? JSON.parse(getLocalSprig) : null;

        if (selectedDevice && selectedDevice.basePathUrl && selectedDevice.installationId) {
                const user = this.appConstants.userDetails
                const userName = user.username
                this.dropDocumentsModal.hide();
                this.docs = [];
                const docs = [];
                const getDocs = Object.assign([], this.selectedDocumentList);
                for (let k = 0; k < getDocs.length; k++) {
                    const tagLoop = getDocs[k];
                    for (let j = 0; j < tagLoop.files.length; j++) {
                        const fileLoop = tagLoop.files[j];
                        const obj: any = {};
                        obj.file = fileLoop;
                        obj.fileName = fileLoop.name;
                        obj.referenceId = this.UtilitiesService.UUID().toLowerCase();
                        obj.fileSizeInBytes = fileLoop.size;
                        obj.tags = [{ id: tagLoop.id }];
                        docs.push(Object.assign({}, obj));
                        this.docs.push(Object.assign({}, obj));
                    }
                }
                const modify = Object.assign([], docs);
                if (modify.length)
                    modify.forEach(element => {
                        delete element.file;
                    });
                const obj = { userName: this.userInfo.email, aboutPath: this.scheduleInfo.aboutPath, installationId: this.selectedDevice.installationId, documents: modify };
                const url = this.appConstants.endPoints.sprigEndPoint + 'documents/' + GlobalConstants.scheduleApplicationID + '/documents/multiple';
                this.service.post(url, {}, obj, true).subscribe(response => {
                    // this.toastr.success(this.translate.instant("Activity Created"));              
                    let uploadInfo = [];
                    const docResult = response.body;
                    for (let i = 0; i < docResult.length; i++) {
                        for (let l = 0; l < this.docs.length; l++) {
                            if (docResult[i].referenceId == this.docs[l].referenceId) {
                                const url = this.selectedDevice.basePathUrl + '/documents/upload/' + docResult[i].id + '?uk=1&installationId=' + this.selectedDevice.installationId + '&fileSize=' + this.docs[l].file.size + '&userName=' + userName + '&fileName=' + encodeURIComponent(this.docs[l].file.name);
                                uploadInfo.push({
                                    id: docResult[i].id,
                                    url: url,
                                    param: null,
                                    method: 'PUT',
                                    fieldName: 'fileUpload',
                                    body: this.docs[l].file
                                })
                            }
                        }
                    }
                    this.UploadService.receiveFiles.next({ upload: uploadInfo });
                }, err => {

                });
            }
        else
            this.authService.checksprigAvailable.next({ sprigNotAvailable: true, modalTitle: this.translate.instant('administration_unableToUploadDocuments_label') })
    }


    allDocumentTypes: Array<any> = [];
    selectedDocumentTags: Array<any> = [];
    selectedDocumentList: Array<any> = [];
    scheduleInfo: any = {};
    dropDocumentsLoader: boolean = false;
    open(obj) {
        this.selectedDocumentTags = [];
        this.selectedDocumentList = [];
        const getSelectedSprig = JSON.parse(localStorage.getItem('selectedDevice'));
        if (getSelectedSprig)
            this.selectedDevice = getSelectedSprig;
        this.scheduleInfo = obj;
        this.dropDocumentsModal.show();
        this.dropDocumentsLoader = true;
        this.getDocumentTags().then((data: any) => {
            data.options = data.options.map(function (obj) { return { "id": obj.uuid, "name": obj.name } });
            this.allDocumentTypes = data.options;
            if (data.selectedOptions.length > 0) {
                this.selectedDocumentTags = data.selectedOptions.map((obj) => { return obj.uuid });
                this.selectedDocumentList = data.selectedOptions.map((obj) => { return { id: obj.uuid, name: obj.name, files: [] } });
            }
            this.dropDocumentsLoader = false;

        })
    }

    removeTag(e) {
        if (e && e.value) {
            const index = this.selectedDocumentList.findIndex(res => res.id == e.value.id)
            if(index != -1)
                this.selectedDocumentList.splice(index, 1);
        }
    }

    addTag(e) {
        this.selectedDocumentList.push({ id: e.id, name: e.name, files: [] })
    }

    removeSelectedType(obj, index) {
        const selectedTags = Object.assign([], this.selectedDocumentTags);
        const tagIndex = selectedTags.indexOf(obj.id);
        selectedTags.splice(tagIndex, 1);
        this.selectedDocumentTags = [];
        this.selectedDocumentTags = Object.assign([], selectedTags);
        if (obj && obj.files) {
            obj.files = [];
        }
        this.selectedDocumentList.splice(index, 1);
    };
    
    isLoading: boolean = false
    async getDocumentTags() {
        this.isLoading = true
            const user = this.appConstants.userDetails
            const userName = user.username
            return new Promise((resolve, reject) => {
                const url = this.appConstants.endPoints.sprigEndPoint + "preferences/" + GlobalConstants.scheduleApplicationID + "/preferred_tags";
                 this.service.get(url, { userName: userName })
                    .pipe(finalize(() => {
                        this.isLoading = false;
                    })).subscribe(res => {
                        resolve(res);
                    }, err => {
                        reject(err);
                    });
            })
    }
    
    docs: any = [];
    fileFilterDocType(parent) {
        if (typeof parent != 'undefined') {
            if (typeof this.docs != 'undefined') {
                let children = [];
                for (let i = 0; i < this.docs.length; i++) {
                    if (this.docs[i].documentType.uuid == parent.id) {
                        children.push(this.docs[i]);
                    }
                }
                return children;
            }
        }
    };

    removeFile(id) {
        this.selectedDocumentList.forEach(res => {
            const index = res.files.findIndex(file => file.id == id);
            if (index != -1)
                res.files.splice(index, 1);
        })
    }

    checkSelectedDocsValidation() {
        if (this.dropDocumentsModal && this.dropDocumentsModal._isShown) {
            let isDisabled = false;
            if (this.selectedDocumentList && this.selectedDocumentList.length) {
                isDisabled = this.selectedDocumentList.some(e => {
                    return e.files.length < 1;
                })
            }
            else
                isDisabled = true;
            return isDisabled;
        }
    }
}
